import { ListTagReviewBatchesV2, ListTagReviewBatchesV2Variables } from './__generated__/ListTagReviewBatchesV2'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListTagReviewBatchesV2($input: ListTagReviewBatchesInputV2) {
    listTagReviewBatches: listTagReviewBatchesV2(input: $input) {
      batches {
        id
        title
        description
        status
        createdAt
        counts {
          total
          pending
          queued
          processing
          completed
          rejected
          error
        }
      }
      nextCursor
    }
  }
`

export const useListTagReviewBatches = (
  variables?: ListTagReviewBatchesV2Variables,
  options?: { fetchPolicy?: 'cache-and-network' | 'cache-first' | 'network-only' | 'no-cache' }
) => {
  return useQuery<ListTagReviewBatchesV2, ListTagReviewBatchesV2Variables>(QUERY, {
    fetchPolicy: options?.fetchPolicy ?? 'cache-and-network',
    variables
  })
}
